import styled, { css } from 'styled-components';

import ActionButton from 'components/action-button';
import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';
import LoadingAnimation from 'components/loading-animation';
import LoyaltyRewardsLogo from 'pages/loyalty/loyalty-rewards-logo';
import { fadeIn } from 'utils/style/animations';

import { LoyaltyGreetingWidget } from '../loyalty-widgets';

const verticalCenter = css`
  display: flex;
  align-items: center;
`;

export const Wrapper = styled.div`
  ${verticalCenter}
  cursor: pointer;
  min-height: 2.5rem;
  overflow: hidden;
  justify-content: space-between;
  background-color: ${Styles.color.contrastBackground};
  animation: ${fadeIn} 0.4s forwards;
  font-weight: ${Styles.fontWeight.heavy};
`;

export const PointsWrapper = styled.div`
  ${verticalCenter}
  padding: 0 0.75rem;
  p {
    font-weight: bold;
    line-height: 1rem;
  }
  svg {
    width: 6.25rem;
  }
  span {
    color: ${Styles.color.primary};
  }
  ${Styles.mobileTiny`
    svg {
      width: 5rem;
    }
     padding: 0.5rem 0.5rem 0.625rem;
  `}
`;

export const CTAWrapper = styled.div`
  ${verticalCenter}
  margin: 0;
  max-height: 5.875rem;
  justify-content: space-between;
  padding: 0 0.75rem;
  width: 100%;
`;

export const PointText = styled.p`
  font-family: ${Styles.fontFamily.brand};
  color: ${Styles.color.white};
  margin: 0;
  ${Styles.mobileTiny`
    font-size: 0.95rem;
  `}
`;

const baseTextStyle = css`
  margin: 0;
  color: ${Styles.color.white};
`;

export const P = styled.p<{ bold?: boolean }>`
  ${baseTextStyle}
  font-size: 0.875rem;
  ${p => p.bold && 'font-weight: bold'};
`;

export const Balance = styled.div`
  ${verticalCenter}
  animation: ${fadeIn} .25s forwards;
  div {
    display: none;
  }
`;

export const TextContainer = styled.div`
  ${verticalCenter};
  align-items: baseline;
  flex-direction: row;
`;

export const StyledPointsIcon = styled(LoyaltyPointsIcon)`
  margin-right: 0.5rem;
  && {
    height: 2rem;
    width: 2rem;
    ${Styles.mobileTiny`
      height: 1.75rem;
      width: 1.75rem;
      margin-right: 0.3rem;
  `}
  }
`;

export const PointBalancePointsIcon = styled(LoyaltyPointsIcon)`
  margin: 0 0.25rem;
  path {
    fill: ${Styles.color.success};
  }
  && {
    height: 1.1rem;
    width: 1.1rem;
  }
`;

const baseCTASyle = css`
  color: ${Styles.color.white};
  font-family: ${Styles.fontFamily.brand};
  font-size: 1rem;
  text-transform: none;
`;

export const JoinNowCTA = styled(ActionButton)`
  ${baseCTASyle}
  margin: 0 0 0 0.25rem;
`;

export const GreetingWrapper = styled(LoyaltyGreetingWidget)`
  ${baseTextStyle}
  display:flex;
  align-items: baseline;
  justify-content: flex-end;
  white-space: nowrap;
  width: 58%;
  font-size: 0.875rem;
  padding: 0 0.75rem;
  overflow: hidden;
  animation: ${fadeIn} 0.25s forwards;
  span {
    ${baseCTASyle}
    line-height: 1.4rem;
    margin: 0 0 0 0.25rem;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  ${Styles.mobileTiny`
    padding: 0 0.5rem 0.125rem;
    font-size: 0.8rem;
    span {
      font-size: 0.95rem;
    }
  `}
`;

export const StyledLoadingAnimation = styled(LoadingAnimation)`
  margin-right: 0.5rem;
  margin-left: 1rem;
`;

export const JoinNowContainer = styled.div`
  ${verticalCenter}
`;

export const StyledLoyaltyRewardsLogo = styled(LoyaltyRewardsLogo)`
  min-width: 6.25rem;
  margin-top: 0.5rem;
`;
